import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgMeal = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.25 6.955v3.553m2.847-9.08H.93v2.62c0 1.615.654 2.907 2.583 2.907 1.93 0 2.584-1.292 2.584-2.907v-2.62ZM3.514 6.955v3.553m-1.94 0H5.45M9.465.935v10.142M7.861.924v3c0 .43.321 1.291 1.604 1.291 1.282 0 1.603-.861 1.603-1.292v-3"
      stroke="#17181A"
    />
  </svg>
);
const Memo = memo(SvgMeal);
export default Memo;
